import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import urls from "../../network/urls";
import "./appMenu-view.css";
import { version } from "../../../package.json";

class Menu extends Component {
  closeSidebar = () => {
    document.body.classList.remove('sidebar-open');
  };

  // Group menu items by category
  getMenuItems() {
    return [
      {
        category: "Main",
        items: [
          {
            to: "/dashboard",
            icon: "fas fa-tachometer-alt",
            text: "Dashboard",
            permission: true,
            badge: this.props.dashboardAlerts,
          },
          {
            to: "/calendar",
            icon: "fas fa-calendar-alt",
            text: "Calendar",
            permission: this.props.appointmentP && this.props.appointmentP.r,
          },
          {
            to: "/statuses",
            icon: "fas fa-table-columns",
            text: "Job Board",
            permission: this.props.appointmentP && this.props.appointmentP.r,
          },
        ],
      },
      {
        category: "Finance",
        items: [
          {
            to: "/invoices",
            icon: "fas fa-file-invoice-dollar",
            text: "Invoices",
            permission: this.props.invoiceP && this.props.invoiceP.c,
          },
          {
            to: "/expenses",
            icon: "fas fa-receipt",
            text: "Expenses",
            permission: this.props.expensesP && this.props.expensesP.c,
          },
          {
            to: "/accounting",
            icon: "fas fa-calculator",
            text: "Accounting",
            permission: this.props.invoiceP && this.props.invoiceP.c,
          },
        ],
      },
      {
        category: "Contacts",
        items: [
          {
            to: "/clients",
            icon: "fas fa-users",
            text: "Clients",
            permission: this.props.clientsP && this.props.clientsP.c,
          },
          {
            to: "/suppliers",
            icon: "fas fa-truck",
            text: "Suppliers",
            permission: this.props.clientsP && this.props.clientsP.c,
          },
        ],
      },
      {
        category: "Management",
        items: [
          {
            to: "/incidents",
            icon: "fas fa-exclamation-triangle",
            text: "Incidents",
            permission: this.props.invoiceP && this.props.invoiceP.c,
          },
        ],
      },
      {
        category: "Settings",
        items: [
          {
            to: "/company-settings",
            icon: "fas fa-building",
            text: "Company Settings",
            permission: this.props.settingsP && this.props.settingsP.u,
          },
          {
            to: "/invoiceTemplates",
            icon: "fas fa-file-contract",
            text: "Invoice Templates",
            permission: this.props.user && this.props.user.rank === "super",
          },
          {
            to: "/statementTemplates",
            icon: "fas fa-file-invoice",
            text: "Statement Templates",
            permission: this.props.user && this.props.user.rank === "super",
          },
          {
            to: "/templates",
            icon: "fas fa-file",
            text: "Document Templates",
            permission: this.props.user && this.props.user.rank === "super",
          },
          {
            to: "/diagram",
            icon: "fas fa-calendar-check",
            text: "Appointment Settings",
            permission: this.props.user && this.props.user.rank === "super",
          },
        ],
      },
    ];
  }

  // Per-tab accent colours (v4 mockup): active item's icon + left dot use these
  static ACCENTS = {
    '/dashboard': '#0DA1B2',
    '/calendar': '#2563EB',
    '/statuses': '#2563EB',
    '/invoices': '#0DA1B2',
    '/expenses': '#7C5CFC',
    '/accounting': '#1B9F69',
    '/clients': '#4F46E5',
    '/suppliers': '#0891B2',
    '/incidents': '#E5A000',
    '/company-settings': '#0DA1B2',
    '/invoiceTemplates': '#0DA1B2',
    '/statementTemplates': '#0DA1B2',
    '/templates': '#0DA1B2',
    '/diagram': '#2563EB',
  };

  renderMenuItem = ({ to, icon, text, permission, badge }) => {
    if (!permission) return null;

    const accent = Menu.ACCENTS[to] || 'var(--primary)';

    return (
      <li className="nav-item" key={to}>
        <NavLink
          to={to}
          style={{ ['--item-accent']: accent }}
          className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
        >
          <i className={`nav-icon ${icon}`}></i>
          <p>
            {text}
            {badge > 0 && <span className="badge badge-danger">{badge}</span>}
          </p>
        </NavLink>
      </li>
    );
  };

  render() {
    const menuItems = this.getMenuItems();

    return (
      <>
        <aside className="main-sidebar">
          <Link to="/" className="brand-link">
            {this.props.company && this.props.company.companyLogo ? (
              <img
                src={`${urls.getImages()}/${this.props.company.companyLogo}`}
                alt="Company Logo"
                className="brand-image"
              />
            ) : (
              <img
                src="/moneyapp_icon_white.png"
                alt="MoneyApp Logo"
                className="brand-image"
              />
            )}
            <div className="brand-meta">
              {this.props.company ? (
                <Link to="/companies" className="brand-text">
                  {this.props.company.companyName}
                </Link>
              ) : (
                <span className="brand-text">MoneyApp</span>
              )}
            </div>
          </Link>

          <div className="sidebar">
            <nav className="mt-2">
              {menuItems.map((group, index) => (
                <div key={index}>
                  {group.items.some((item) => item.permission) && (
                    <>
                      <div className="nav-header">{group.category}</div>
                      <ul className="nav nav-pills nav-sidebar flex-column">
                        {group.items.map((item) => this.renderMenuItem(item))}
                      </ul>
                    </>
                  )}
                </div>
              ))}
            </nav>
          </div>
          <div className="sidebar-version">
            <span>v{version}</span>
            <span>© {new Date().getFullYear()}</span>
          </div>
        </aside>

        {/* Mobile menu overlay */}
        <div
          className="sidebar-overlay"
          onClick={this.closeSidebar}
        />
      </>
    );
  }
}

export { Menu };
